import { Heart, FileText, Users, Bot, Repeat, Download, Link } from "lucide-react";

import Box from '../../components/Box';
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";

const teamMembers = [
  {
    icon: <Heart className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Self Healer",
    description: "Scans the system and fixes issues automatically before anyone notices.",
  },
  {
    icon: <FileText className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Record & Report",
    description: "1-click issue reporting — screen record and speak the issue to send it instantly to the right team.",
  },
  {
    icon: <Users className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Virtual Relationship Manager",
    description: "Onboarding in under 10 minutes. A human + AI manager for any help you need.",
  },
  {
    icon: <Bot className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Chatbot",
    description: "Always-on, click-based virtual IT expert. Removes the need to train IT staff.",
  },
  {
    icon: <Repeat className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Task Automation",
    description: "Automates daily and monthly workflows — saves hours of manual work. (Coming Soon)",
  },
  {
    icon: <Repeat className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Data Migration",
    description: "Transfers your old systems' data into SooMuchAI with zero errors — under 3 minutes.",
  },
  {
    icon: <Download className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "App Download Automator",
    description: "Ensures all parents install the app — 3 automated attempts, teacher follow-up, and major cost savings.",
  },
  {
    icon: <Link className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Social Media Connector",
    description: "Auto-invites app users to follow your school's verified social pages — grow your brand effortlessly.",
  }
];

export default function EverthingYourSchoolNeed() {

  return <Box
        badge={"YOUR SUPPORT TEAM"}
        title={"Everything Your School Needs - Fully Automated"}
        leftBlock={teamMembers.slice(0, 2).map((member, index) => <MarktingCard key={"memberUpperCardEveryThingYourSchoolNeed" + index} member={member} />)}
        rightBlock={teamMembers.slice(2).map((member, index) => <MarktingCard key={"memberUpperCardEveryThingYourSchoolNeed" + index} member={member} />)}
      />;
}